/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Blocksignoffdaysinadvance5Inputs */

const en__field_blocksignoffdaysinadvance5 = /** @type {(inputs: _Field_Blocksignoffdaysinadvance5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signoff Block Range`)
};

const de__field_blocksignoffdaysinadvance5 = /** @type {(inputs: _Field_Blocksignoffdaysinadvance5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmeldefrist`)
};

/**
* | output |
* | --- |
* | "Signoff Block Range" |
*
* @param {_Field_Blocksignoffdaysinadvance5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_blocksignoffdaysinadvance5 = /** @type {((inputs?: _Field_Blocksignoffdaysinadvance5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Blocksignoffdaysinadvance5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_blocksignoffdaysinadvance5(inputs)
	return de__field_blocksignoffdaysinadvance5(inputs)
});
export { _field_blocksignoffdaysinadvance5 as "_field_blockSignOffDaysInAdvance" }